module.exports = __webpack_public_path__ + "static/media/Golo_Circlecheck.4ff8949a.mp4";